import React, { useRef, useState, useEffect } from 'react'
import Tution from '../assets/images/Tution.svg';
import './accountLogin.css';
import copy from '../assets/images/copy.svg';
import lock from '../assets/images/lock.svg';
import rightArraow from '../assets/images/arrow-right.svg';
import { Trans, useTranslation } from "react-i18next";
import { validateMobile, checkLoginNonEmpty ,validateEmail } from "../utils/validation";
import moment from 'moment';
function AccountLogin(props) {
    const { t, i18n } = useTranslation();
    let mobileRef = useRef(null);
    let [mobileError, setMobileError] = useState(false);
    let [emailError, setEmailError] = useState(false);
    let [accountLoginBtnEnabled, setAccountLoginBtnEnabled] = useState(false);
    console.log("loginState",props.loginState)
    useEffect(() => {
        validation();
    }, [props.mobile, props.email]);

    useEffect(() => {
        let loginData = JSON.parse(localStorage.getItem("loginData")) || false
        if (loginData && loginData.mobile) {
            props.setMobileAction(loginData.mobile)
        }
        if (loginData && loginData.email) {
            props.setEmailAction(loginData.email)
        }

    }, []);

    const validation = (type, orgType) => {
        let validity = checkLoginNonEmpty(
            props.mobile,
            props.email,
            props.loginState
        );
        setAccountLoginBtnEnabled(validity);
    };

    const keyPressed = (event) => {
        var code = event && (event.keyCode || event.which);
        if (code === 13) {
            handleOnClick();
        }
    }

    const handleOnClick = () => {
        if(props.loginState==0){
            if (!validateMobile(props.mobile, props.mobileRegex) || !props.mobile) {
                setMobileError(true);
            } else {
                setMobileError(false);
                props.handleGenerateOtp(0);
            }
        }
        else{
            if (!validateEmail(props.email) || !props.email) {
                setEmailError(true);
            } else {
                setEmailError(false);
                props.handleGenerateOtp(0);
        }
        }
        
    };
    return (
        <div className="accountLogin-container">
            <div>
                <div className="accountLogin-welcome-container">
                    <img
                        src={Tution}
                        alt=""
                        className="accountLogin-welcome-logo"
                    />
                </div>
                <p className="accountLogin-welcome-heading">
                 {t("Routes.Login.AccountLogin.WelcomeTo", "Welcome to")}{" "}{props.orgName}{" "}{t("Routes.Login.AccountLogin.WelcomeToPost", "!")}
                </p>
            </div>
            <div className="accountLogin-test-details">
                <div className="accountLogin-test-name">
                    <p>
                        {props.testName}
                    </p>
                    <img src={copy} alt="" />
                </div>
                <div className="accountLogin-test-inst">
                    <div><img src={rightArraow} alt="" /></div><span><Trans i18nKey="Routes.Login.AccountLogin.AttemptTestDescription">Attempt test, get detailed result & analysis</Trans></span>
                </div>
            </div>
           {props.loginState==0 ?( 
           <div className="accountLogin-mobile-field">
                <label className="accountLogin-label">
                    <Trans i18nKey="Routes.Login.AccountLogin.EnterMobileNumberToContinue">
                    Enter your mobile number to continue
                  </Trans></label>
                <input
                    ref={mobileRef}
                    data-cy="login_number"
                    type="number"
                    className="accountLogin-input accountLogin-input-mobile"
                    placeholder={t("Routes.Login.AccountLogin.EnterMobileNumber","Enter your mobile number")}
                    value={props.mobile}
                    onKeyPress={(event) => keyPressed(event)}
                    onChange={e => {
                        setMobileError(false)
                        const re = /^[0-9\b]+$/;
                        if (
                            e.target.value === "" ||
                            re.test(e.target.value)
                        ) {
                            if (e.target.value.length <= 10) {
                                props.setMobileAction(e.target.value);
                            }
                        }
                    }}
                    style={
                        mobileError
                            ? { border: "1px solid #F15123" }
                            : { border: "1px solid #C4CDD5" }
                    }
                />
                <div className="accountLogin-mobile-field-code">
                    +{props.CountryCode}
                </div>
                {mobileError ? (
                    <div className="accountLogin-error">
                        <img
                            src={alert}
                            alt=""
                            style={{ marginRight: "4px" }}
                        />
                        <label className="accountLogin-error-message">
                        {" "}<Trans i18nKey="Routes.Login.AccountLogin.EnterValidMobileNumber">
                            Please enter a valid mobile number</Trans>
                        </label>
                    </div>
                ) : null}
            </div>
           ) : ( 
            <div className="accountLogin-mobile-field">
                 <label className="accountLogin-label">
                   {t("Routes.Login.AccountLogin.enterEmail","Enter Your Email Address")}
                 </label>
                 <input
                     data-cy="login_number"
                     type="text"
                     className="accountLogin-input"
                     placeholder="eg. harshsrivastava@gmail.com"
                     value={props.email}
                     onKeyPress={(event) => keyPressed(event)}
                     onChange={e => {
                        setEmailError(false)
                        props.setEmailAction(e.target.value);
                     }}
                     style={
                        emailError
                             ? { border: "1px solid #F15123" }
                             : { border: "1px solid #C4CDD5" }
                     }
                 />
                 {emailError ? (
                     <div className="accountLogin-error">
                         <img
                             src={alert}
                             alt=""
                             style={{ marginRight: "4px" }}
                         />
                         <label className="accountLogin-error-message">
                             Please enter a valid email address
                         </label>
                     </div>
                 ) : null}
             </div>
            )
           }
            <div className="account-login-footer">
                { <div className="accountLogin-tnc-mob"><div className="accountLogin-tnc-text">{t("Routes.Login.AccountLogin.AgreeT&C","By continuing, you agree to the")}&nbsp;</div><div><a
                    className="accountLogin-tnc-link"
                    target="_blank"
                    rel="noreferrer"
                    href="https://classplusapp.com/termsOfUse.html"
                >{t("Routes.Login.AccountLogin.T&C", "terms and conditions")}
                </a></div></div>}
                <button
                    className={
                        accountLoginBtnEnabled
                            ? "accountLogin-button-enabled"
                            : "accountLogin-button-disabled"
                    }
                    onClick={() => {
                        handleOnClick();
                    }}
                    data-cy="login_continue"
                >
                    <img src={lock} alt="" className="lockImg" />{t("Routes.Login.AccountLogin.ProceedSecurely", "Proceed Securely")}
                </button>
                {<div className="accountLogin-tnc"><div className="accountLogin-tnc-text">{t("Routes.Login.AccountLogin.AgreeT&C","By continuing, you agree to the")}&nbsp;</div><div><a
                    className="accountLogin-tnc-link"
                    target="_blank"
                    rel="noreferrer"
                    href="https://classplusapp.com/termsOfUse.html"
                >  {t("Routes.Login.AccountLogin.T&C", "terms and conditions")}
                </a></div> </div>}
            </div>
        </div>
    )
}

export default AccountLogin
